module.exports = __webpack_public_path__ + "img/header-2.cde4a2be.jpg";